module.exports = __webpack_public_path__ + "static/img/icon-arrow.af199ac.png";